export let config = {
    headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": process.env.https://api.nrtdashboard.prod.inet.paynet.my,
       
    },
};

export function setAuthToken() {
    const token = localStorage.getItem('accessToken');
    if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
        console.log(`Bearer ${token}`);
    } else {
        console.error("No access token found in local storage.");
    }
}
